import React, { Component, useEffect } from "react";
import { Route, Routes, Navigate, useLocation } from "react-router-dom";
import { Layout } from "antd";
import DocPage from "./components/docPage/docPage";
import { HomePage } from "./components/homePage/homePage";
import BrowsePage from "./components/browsePage/BrowsePage";
import { RabisuTopBar, RabisuMainNav } from "./components/header/RabisuHeader";
import RabisuFooter from "./components/footer/RabisuFooter";

import "./App.css";

/* Route değişince sayfayı en üste taşı */
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

export default class App extends Component {
  render() {
    return (
      <>
        <div className="global-bg"></div>
        <RabisuTopBar />
        <RabisuMainNav />
        <Layout className="main-layout">
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Navigate to="/home" replace />} />
            <Route path="/home" element={<HomePage />} />
            <Route path="/browse/*" element={<BrowsePage />} />
            <Route path="/doc/*" element={<DocPage />} />
          </Routes>
        </Layout>
        <RabisuFooter />
      </>
    );
  }
}
